module.exports = __webpack_public_path__ + "img/retis_small.b123107b.png";